import React from 'react';
import EventItem from './eventItem';

const EventList = (props) => {
  const { events } = props;

  const eventItems = events.map((event, i) => {
    return (
      <EventItem key={i} event={event} />
    );
  })

  return (
    <ul className="timeline timeline-centered">
      {eventItems}
    </ul>
  );
}

export default EventList;
